<div class="image-background">
  <div class="browse-title-container">
    <div class="image-text-container">
      <ion-text class="image-text">
        {{ 'i18n.search.browsePage.titleImage' | translate }}
      </ion-text>
    </div>
  </div>
</div>
